/* eslint-disable consistent-return, no-async-promise-executor */
import { useEffect } from 'react'
import { loadReCaptcha } from 'react-recaptcha-v3'

const sleep = milsec =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, milsec)
  })

const withRecaptcha = (siteKey, action, verifyUrl, isProd) => Component => {
  return function InnerComponent(props) {
    if (isProd && !window.grecaptcha) {
      // biome-ignore lint/correctness/useHookAtTopLevel: TODO
      useEffect(() => {
        loadReCaptcha(siteKey)
      }, [])
    }

    const verify = async (siteKey, retry) => {
      if (!isProd) {
        return { success: true }
      }
      if (retry > 5) {
        return {
          success: false,
          error: 'Recaptcha Error: Something went wrong.',
        }
      }
      if (!window.grecaptcha) {
        await sleep(1000)
        const result = await verify(siteKey, retry + 1)
        return result
      }
      const reCapToken = await window.grecaptcha.execute(siteKey, {
        action,
      })
      const response = await fetch(verifyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: reCapToken }),
      })
      const json = await response.json()
      return { success: json.success }
    }

    return (
      <Component
        {...props}
        recaptcha={() =>
          // biome-ignore lint/suspicious/noAsyncPromiseExecutor: TODO
          new Promise(async (resolve, reject) => {
            const result = await verify(siteKey, 0)
            if (!result.success) {
              return reject(result?.error || null)
            }
            resolve()
          })
        }
      />
    )
  }
}

export default withRecaptcha
